import { ActivatedRouteSnapshot, Route, Routes } from '@angular/router';
import { PriceListArea, PriceListAreaEnum } from './models/pricelist-area.model';
import { priceListPaths } from './pricelist-paths';
import { RowPriceListsPortalComponent } from './components/row-pricelists-portal/row-pricelists-portal.component';
import { EuPriceListsPortalComponent } from './components/eu-pricelists-portal/eu-pricelists-portal.component';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { PriceListRoutes } from './models/pricelist.routes';
import { validYearGuard, yearMatcher } from './guards';
import { inject, Type } from '@angular/core';
import { PriceListsDefaultYearResolverService, PriceListsDynamicYearResolverService } from './resolvers';

function getPriceListRoute(area: PriceListArea, path: string, component: Type<unknown>): Route {
  return {
    path,
    component,
    resolve: {
      priceListsData: (route: ActivatedRouteSnapshot) => inject(PriceListsDefaultYearResolverService).resolve(area, route),
    },
    children: [
      {
        path: ':year',
        component,
        canActivate: [validYearGuard],
        resolve: {
          priceListsData: (route: ActivatedRouteSnapshot) => inject(PriceListsDynamicYearResolverService).resolve(area, route),
        },
      },
    ],
  };
}

export const routes: Routes = [
  {
    path: '',
    component: RowPriceListsPortalComponent,
    resolve: {
      priceListsData: (route: ActivatedRouteSnapshot) => inject(PriceListsDefaultYearResolverService).resolve(PriceListAreaEnum.ROW, route),
    },
    children: [
      {
        matcher: yearMatcher,
        component: RowPriceListsPortalComponent,
        canActivate: [validYearGuard],
        resolve: {
          priceListsData: (route: ActivatedRouteSnapshot) => inject(PriceListsDynamicYearResolverService).resolve(PriceListAreaEnum.ROW, route),
        },
      },
    ],
  },

  // /row and /row/:year
  getPriceListRoute(PriceListAreaEnum.ROW, priceListPaths[PriceListAreaEnum.ROW], RowPriceListsPortalComponent),

  // /eu and /eu/:year
  getPriceListRoute(PriceListAreaEnum.EU, priceListPaths[PriceListAreaEnum.EU], EuPriceListsPortalComponent),

  // Error pages
  {
    path: PriceListRoutes.NOT_FOUND,
    component: ErrorPageComponent,
  },
  {
    path: PriceListRoutes.FORBIDDEN,
    component: ErrorPageComponent,
    data: { forbidden: true },
  },
  {
    path: '**',
    redirectTo: '/404',
  },
];
